<template>
  <div class="locale-changer">
    <q-bar class="bg-white">
      <q-btn dense flat round :to="{ name: 'MoreIndex' }">
        <i class="fas fa-chevron-left"></i>
      </q-btn>
      <div class="col text-center">{{ $t(currentMore.key) }}</div>
    </q-bar>
    <q-list>
      <q-item
        v-for="(value, key) in availableLocales"
        :key="key"
        v-ripple
        tag="label"
      >
        <q-item-section avatar>
          <q-radio v-model="language" :val="key" />
        </q-item-section>
        <q-item-section>
          <q-item-label>{{ availableLocales[key] }}</q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { availableLocales, defaultLocale } from '@/locales';

export default {
  name: 'Language',
  data() {
    return {
      availableLocales,
      language: '',
    };
  },
  computed: {
    ...mapState({
      currentMore: (state) => state.more.currentMore,
      locale: (state) => state.lang,
    }),
  },
  watch: {
    language(newValue) {
      this.setLocale(newValue);
    },
  },
  mounted() {
    this.language = this.locale || defaultLocale;
  },
  methods: {
    ...mapMutations({ setLang: 'SET_LANG' }),

    setLocale(value) {
      this.setLang(value);
      this.$i18n.locale = value;
    },
  },
};
</script>
